import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { formatINR } from "./format";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price) {
  return formatINR(price);
}

export function getInitials(name) {
  return String(name || "SY")
    .split(" ")
    .map(part => part[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}
